module.exports = __webpack_public_path__ + "img/icon_tel.9b40070c.png";